export default "__VITE_ASSET__ca859594__"